import EmptyRoundedRectangleIcon from '@assets/icons/empty-rounded-rectangle.svg';
import i18n from '@/utils/i18n';
import { EmptyState } from '@/components/empty-state';
import { InboundListFilter } from './types';
import { useTheme } from '@/contexts/theme-context';
import type { ViewStyle } from 'react-native';

const TITLE_KEYS: Record<InboundListFilter, string> = {
  [InboundListFilter.All]: 'order_inbounds.empty_state.all.title',
  [InboundListFilter.Open]: 'order_inbounds.empty_state.open.title',
  [InboundListFilter.Closed]: 'order_inbounds.empty_state.closed.title',
};

interface Props {
  filter: InboundListFilter;
  style?: ViewStyle;
}

export const OrderInboundsOrderListEmptyState: React.FC<Props> = ({
  filter,
  style,
}) => {
  const theme = useTheme();

  return (
    <EmptyState
      description={i18n.t('order_inbounds.empty_state.description')}
      icon={<EmptyRoundedRectangleIcon stroke={theme.sk.color.icon.primary} />}
      style={style}
      title={i18n.t(TITLE_KEYS[filter])}
    />
  );
};
